import TableReclamation from "@components/TableReclamation/TableReclamation";
import React from "react";
import ROUTES from "@config/routes";
import { TableHeaderReclamationAdmin } from "../../models/TableHeaderReclamation";
import { IFilterAllReclamationData } from "@modules/reclamation/dtos/IFilterAllReclamationData";

interface ITableReclamationAllProps {
  queryDataReclamationUser?: IFilterAllReclamationData;
  status: string;
}
const TableReclamationAll: React.FC<ITableReclamationAllProps> = ({
  ...props
}) => {
  return (
    <TableReclamation
      tableHeaderColumn={TableHeaderReclamationAdmin}
      tableData={props.queryDataReclamationUser}
      positionStatusTag={7}
      positionRecordTypeTag={6}
      positionButtonSeeDetails={7}
      positionID={5}
      hasButtonSeeDetails={true}
      linkRouteReclamation={ROUTES.ADMIN_ROUTES.RECLAMATION_DETAILS_ADM}
      isListAdmin={true}
    />
  );
};

export default TableReclamationAll;
